import { GRID_STRING_COL_DEF } from '@mui/x-data-grid';

export function WebsiteCell(params){

    var websiteURL = ""
    if (Object.keys(params).length === 1) websiteURL = params.url; //ChannelPage case
    else websiteURL = params.row.website_vod_assets; //StationsPage case
    if (websiteURL === undefined) return ""; //Not found case

    const siteName = parseWebsiteURL(websiteURL)
    return (
        <a href={"https://www." + siteName} target="_blank" rel="noopener noreferrer" className={'WebsiteCell'}>{siteName}</a>
    )
}


function parseWebsiteURL(websiteURL){
    var siteName = websiteURL.trim()

    if (siteName.substring(0,8) === "https://") siteName = siteName.substring(8)
    if (siteName.substring(0,7) === "http://") siteName = siteName.substring(7)
    if (siteName.substring(0,4) === "www.") siteName = siteName.substring(4)
    if (siteName.substring(siteName.length-1) === "/") siteName = siteName.substring(0, siteName.length-1)
    
    return siteName
}


export function WebsiteCellType(){
    return {
        ...GRID_STRING_COL_DEF,
        type: 'custom',
        resizable: true,
        filterable: false,
        sortable: false,
        editable: false,
        groupable: false,
        display: 'flex',
        renderCell: (params) => <WebsiteCell {...params} />,
    };
}
